import React from 'react'
import './loading.css';

const Loading = () => {
  return (
    <div className="container flex justify-center">
      <div className="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading/Loading.js